import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomerPersonItem } from '@app/services/economy.service';
import { BusinessItem, CoopItem } from '@app/services/logistic.service';
import { OrderHeadGet } from '@app/services/orderhead.service';
import { CustomerItem, SearchProjectItem, ServiceObjectItem, TypeaheadService } from '@app/services/typeahead.service';
import { OrderHeadCustomerFormGroup } from '@app/views/components/order-head/order-head-edit/order-head-edit.component';

@Component({
    selector: 'tt-order-head-customer-address-form',
    templateUrl: './order-head-customer-address-form.component.html',
    styleUrls: ['./order-head-customer-address-form.component.css'],
})
export class OrderHeadCustomerAddressFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public form?: FormGroup<OrderHeadCustomerFormGroup>;

    @Input()
    public customerPersons: CustomerPersonItem[] = [];

    @Input()
    public businesses: BusinessItem[] = [];

    @Input()
    public coops: CoopItem[] = [];

    constructor(private typeahead: TypeaheadService) {}

    public searchCustomers = (params?: { [key: string]: any }) => {
        return this.typeahead.searchCustomer({ cust_name: params?.['value'] ?? '', custtype: 'C', lastselect: 'SEARCH' });
    };

    public searchProjects = (params?: { [key: string]: any }) => {
        return this.typeahead.searchProjects({ project_name: params?.['value'] ?? '', cust_no: this.form?.controls.stat_cust_no.value ?? '', businessco_no: this.get?.businessco_no });
    };

    public searchServiceObjects = (params?: { [key: string]: any }) => {
        return this.typeahead.searchServiceObjects({ searchtext: params?.['value'] ?? '' });
    };

    public onCustomerSelected(event?: CustomerItem) {
        this.form?.patchValue({ stat_cust_no: event?.item_id ?? '0', stat_cust_name: event?.item_name ?? '' });
    }

    public onProjectSelected(event?: SearchProjectItem) {
        this.form?.patchValue({ project_keyno: event?.item_id ?? '0', project_name: event?.item_name ?? '' });
    }

    public onServiceObjectSelected(event?: ServiceObjectItem) {
        this.form?.patchValue({ serviceobject_keyno: event?.item_id ?? '0', serviceobject_name: event?.item_name ?? '' });
    }
}
